import {GET} from '../http';

export const GetNotesCount = spec=>{
    return GET("Home/GetNotesCount",spec)
}
